import { FileUploadSetting } from 'backend';
import {
  FileUploadSessionStateReady,
  FileUploadState,
  FILE_UPLOAD_SESSION_STATE_TYPE,
} from 'store';

type FileUploadStateReady = Pick<FileUploadState, 'items'> & {
  session: FileUploadSessionStateReady;
  setting: FileUploadSetting;
};

export const isFileUploadStateReady = (
  fileUploadState: FileUploadState,
): fileUploadState is FileUploadStateReady =>
  fileUploadState.setting != null &&
  fileUploadState.session.type === FILE_UPLOAD_SESSION_STATE_TYPE.ready;
